/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @type RangeQueryValueLte
 * Less than or equal.
 * @export
 */
export type RangeQueryValueLte = number | string;

export function RangeQueryValueLteFromJSON(json: any): RangeQueryValueLte {
    return RangeQueryValueLteFromJSONTyped(json, false);
}

export function RangeQueryValueLteFromJSONTyped(json: any, ignoreDiscriminator: boolean): RangeQueryValueLte {
    if (json == null) {
        return json;
    }
    if (typeof json === 'number') {
        return json;
    }
    if (typeof json === 'number') {
        return json;
    }
    if (typeof json === 'string') {
        return json;
    }
    return {} as any;
}

export function RangeQueryValueLteToJSON(json: any): any {
    return RangeQueryValueLteToJSONTyped(json, false);
}

export function RangeQueryValueLteToJSONTyped(value?: RangeQueryValueLte | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'string') {
        return value;
    }
    return {};
}

